// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pulsing-mic {
  animation: pulse 2s infinite;
  color: white;
  background-color: #4caf50;
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(76, 175, 80, 0.6);
  }
  70% {
    box-shadow: 0 0 0 16px rgba(76, 175, 80, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(76, 175, 80, 0);
  }
}

.sticky {
  position: sticky;
  top: 0;
  z-index: 1000; /* To make sure it stays above other elements */
}

.dot {
  width: 8px;
  height: 8px;
  background-color: rgba(24, 116, 210, 0.6);
  border-radius: 50%;
  display: inline-block;
  animation: blink 1.2s infinite ease-in-out;
}
.dot:nth-child(2) {
  animation-delay: 0.2s;
}
.dot:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes blink {
  0%,
  80%,
  100% {
    opacity: 0.3;
    transform: scale(0.8);
  }
  40% {
    opacity: 1;
    transform: scale(1);
  }
}

/* Enhanced Markdown Styles */
.markdown-content {
  word-wrap: break-word;
  overflow-wrap: break-word;
  line-height: 1.6;
  counter-reset: code-block;
  color: #2c3e50 !important;
}

.markdown-content pre {
  background-color: #ffffff;
  border: 1px solid rgba(24, 116, 210, 0.12);
  border-radius: 8px;
  padding: 16px;
  overflow-x: auto;
  margin: 16px 0;
  position: relative;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

/* Force dark text for all common markdown elements */
.markdown-content p,
.markdown-content li,
.markdown-content td,
.markdown-content th,
.markdown-content blockquote,
.markdown-content span,
.markdown-content div {
  color: #2c3e50 !important;
}

.markdown-content pre code {
  background: none;
  padding: 0;
  border-radius: 0;
  font-size: 0.9rem;
}

.markdown-content table {
  border-collapse: collapse;
  width: 100%;
  margin: 16px 0;
  font-size: 0.9rem;
  border: 1px solid rgba(24, 116, 210, 0.12);
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.markdown-content table th,
.markdown-content table td {
  border: 1px solid rgba(24, 116, 210, 0.08);
  padding: 8px 12px;
  text-align: left;
}

.markdown-content table th {
  background-color: rgba(24, 116, 210, 0.04);
  font-weight: bold;
  color: #002855;
}

.markdown-content table tr:nth-child(even) {
  background-color: rgba(24, 116, 210, 0.02);
}

.markdown-content table tr:hover {
  background-color: rgba(24, 116, 210, 0.04);
}

.markdown-content blockquote {
  border-left: 4px solid rgba(24, 116, 210, 1);
  margin: 16px 0;
  padding: 12px 16px;
  background-color: rgba(24, 116, 210, 0.04);
  border-radius: 0 4px 4px 0;
  font-style: italic;
  position: relative;
  border: 1px solid rgba(24, 116, 210, 0.08);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.markdown-content blockquote p {
  margin: 0;
}

.markdown-content ul,
.markdown-content ol {
  padding-left: 24px;
  margin: 16px 0;
}

.markdown-content li {
  margin-bottom: 4px;
  line-height: 1.6;
}

.markdown-content img {
  max-width: 100%;
  height: auto;
  border-radius: 8px;
  margin: 16px 0;
}

.markdown-content a {
  color: #1976d2;
  text-decoration: underline;
}

.markdown-content a:hover {
  color: #1565c0;
}

.markdown-content hr {
  border: 1px solid #e0e0e0;
  margin: 24px 0;
}

/* Syntax Highlighter Custom Styles */
.markdown-content .token.comment,
.markdown-content .token.prolog,
.markdown-content .token.doctype,
.markdown-content .token.cdata {
  color: #6a737d;
}

.markdown-content .token.punctuation {
  color: #586069;
}

.markdown-content .token.property,
.markdown-content .token.tag,
.markdown-content .token.boolean,
.markdown-content .token.number,
.markdown-content .token.constant,
.markdown-content .token.symbol,
.markdown-content .token.deleted {
  color: #005cc5;
}

.markdown-content .token.selector,
.markdown-content .token.attr-name,
.markdown-content .token.string,
.markdown-content .token.char,
.markdown-content .token.builtin,
.markdown-content .token.inserted {
  color: #032f62;
}

.markdown-content .token.operator,
.markdown-content .token.entity,
.markdown-content .token.url,
.markdown-content .language-css .token.string,
.markdown-content .style .token.string {
  color: #d73a49;
}

.markdown-content .token.atrule,
.markdown-content .token.attr-value,
.markdown-content .token.keyword {
  color: #d73a49;
}

.markdown-content .token.function,
.markdown-content .token.class-name {
  color: #6f42c1;
}

.markdown-content .token.regex,
.markdown-content .token.important,
.markdown-content .token.variable {
  color: #e36209;
}

/* Chat Layout Fixes */
.chat-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
  /* Ensure consistent width for non-fullscreen mode */
  width: 480px;
  max-width: 480px;
  min-width: 480px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

/* Fullscreen mode overrides */
.chat-container.fullscreen {
  width: 100% !important;
  max-width: 100% !important;
  min-width: auto !important;
}

.chat-header {
  flex-shrink: 0;
  overflow: hidden;
}

.chat-body {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
}

.chat-input {
  flex-shrink: 0;
  width: 100%;
  position: relative;
  z-index: 1;
}

/* Prevent content overflow during streaming */
.markdown-content {
  max-width: 100%;
  word-wrap: break-word;
  overflow-wrap: break-word;
  hyphens: auto;
}

/* Fade overlay for collapsible code blocks */
.markdown-content .code-fade-overlay {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 48px;
  background: linear-gradient(
    to bottom,
    rgba(248, 249, 250, 0),
    rgba(248, 249, 250, 1)
  );
  pointer-events: none;
}

/* Context marker button subtle style */
.markdown-content .context-marker-button {
  box-shadow: 0 2px 4px rgba(24, 116, 210, 0.1);
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.markdown-content .context-marker-button:hover {
  box-shadow: 0 4px 8px rgba(24, 116, 210, 0.2);
  transform: translateY(-1px);
}

/* Ensure proper text wrapping in chat messages */
.chat-message {
  word-wrap: break-word;
  overflow-wrap: break-word;
  max-width: 100%;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

/* Smooth animations for message appearance */
@keyframes messageSlideIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.chat-message {
  animation: messageSlideIn 0.3s ease-out;
}

/* Responsive Design */
@media (max-width: 960px) {
  .chat-container:not(.fullscreen) {
    width: 100% !important;
    max-width: 100% !important;
    min-width: 100% !important;
  }

  .markdown-content table {
    font-size: 0.85rem;
  }

  .markdown-content table th,
  .markdown-content table td {
    padding: 8px 10px;
  }

  .markdown-content pre {
    padding: 14px;
    font-size: 0.85rem;
  }
}

@media (max-width: 768px) {
  .chat-container:not(.fullscreen) {
    width: 100% !important;
    max-width: 100% !important;
    min-width: 100% !important;
  }

  .markdown-content table {
    font-size: 0.8rem;
    display: block;
    overflow-x: auto;
    white-space: nowrap;
  }

  .markdown-content table th,
  .markdown-content table td {
    padding: 6px 8px;
  }

  .markdown-content pre {
    padding: 12px;
    font-size: 0.8rem;
    overflow-x: auto;
  }

  .markdown-content ul,
  .markdown-content ol {
    padding-left: 20px;
  }

  .markdown-content blockquote {
    padding: 10px 14px;
    margin: 12px 0;
  }
}

@media (max-width: 600px) {
  .chat-container:not(.fullscreen) {
    width: 100% !important;
    max-width: 100% !important;
    min-width: 100% !important;
  }

  .markdown-content {
    font-size: 0.9rem;
  }

  .markdown-content table {
    font-size: 0.75rem;
  }

  .markdown-content table th,
  .markdown-content table td {
    padding: 5px 6px;
  }

  .markdown-content pre {
    padding: 10px;
    font-size: 0.75rem;
  }

  .markdown-content ul,
  .markdown-content ol {
    padding-left: 18px;
  }

  .markdown-content blockquote {
    padding: 8px 12px;
    margin: 10px 0;
  }

  .markdown-content h1 {
    font-size: 1.5rem;
  }

  .markdown-content h2 {
    font-size: 1.3rem;
  }

  .markdown-content h3 {
    font-size: 1.1rem;
  }
}

@media (max-width: 480px) {
  .chat-container:not(.fullscreen) {
    width: 100% !important;
    max-width: 100% !important;
    min-width: 100% !important;
  }

  .markdown-content {
    font-size: 0.85rem;
  }

  .markdown-content table {
    font-size: 0.7rem;
  }

  .markdown-content table th,
  .markdown-content table td {
    padding: 4px 5px;
  }

  .markdown-content pre {
    padding: 8px;
    font-size: 0.7rem;
  }

  .markdown-content ul,
  .markdown-content ol {
    padding-left: 16px;
  }

  .markdown-content blockquote {
    padding: 6px 10px;
    margin: 8px 0;
    font-size: 0.85rem;
  }

  .markdown-content h1 {
    font-size: 1.3rem;
  }

  .markdown-content h2 {
    font-size: 1.15rem;
  }

  .markdown-content h3 {
    font-size: 1rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/common/chat/index.css"],"names":[],"mappings":"AAAA;EACE,4BAA4B;EAC5B,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE;IACE,0CAA0C;EAC5C;EACA;IACE,2CAA2C;EAC7C;EACA;IACE,wCAAwC;EAC1C;AACF;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,aAAa,EAAE,+CAA+C;AAChE;;AAEA;EACE,UAAU;EACV,WAAW;EACX,yCAAyC;EACzC,kBAAkB;EAClB,qBAAqB;EACrB,0CAA0C;AAC5C;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE;;;IAGE,YAAY;IACZ,qBAAqB;EACvB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA,6BAA6B;AAC7B;EACE,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;EAChB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,0CAA0C;EAC1C,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA,qDAAqD;AACrD;;;;;;;EAOE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,cAAc;EACd,iBAAiB;EACjB,0CAA0C;EAC1C,kBAAkB;EAClB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;;EAEE,0CAA0C;EAC1C,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;EAC1C,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,4CAA4C;EAC5C,cAAc;EACd,kBAAkB;EAClB,0CAA0C;EAC1C,0BAA0B;EAC1B,kBAAkB;EAClB,kBAAkB;EAClB,0CAA0C;EAC1C,yCAAyC;AAC3C;;AAEA;EACE,SAAS;AACX;;AAEA;;EAEE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,qCAAqC;AACrC;;;;EAIE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;;;;;EAOE,cAAc;AAChB;;AAEA;;;;;;EAME,cAAc;AAChB;;AAEA;;;;;EAKE,cAAc;AAChB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,oDAAoD;EACpD,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,iDAAiD;AACnD;;AAEA,8BAA8B;AAC9B;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,UAAU;AACZ;;AAEA,8CAA8C;AAC9C;EACE,eAAe;EACf,qBAAqB;EACrB,yBAAyB;EACzB,aAAa;AACf;;AAEA,6CAA6C;AAC7C;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,SAAS;EACT,YAAY;EACZ;;;;GAIC;EACD,oBAAoB;AACtB;;AAEA,uCAAuC;AACvC;EACE,6CAA6C;EAC7C,iDAAiD;AACnD;;AAEA;EACE,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA,iDAAiD;AACjD;EACE,qBAAqB;EACrB,yBAAyB;EACzB,eAAe;EACf,iDAAiD;AACnD;;AAEA,6CAA6C;AAC7C;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,uCAAuC;AACzC;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;IACtB,0BAA0B;IAC1B,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,0BAA0B;IAC1B,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;;IAEE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,cAAc;EAChB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,0BAA0B;IAC1B,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,kBAAkB;EACpB;;EAEA;;IAEE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,0BAA0B;IAC1B,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,iBAAiB;EACnB;;EAEA;;IAEE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".pulsing-mic {\n  animation: pulse 2s infinite;\n  color: white;\n  background-color: #4caf50;\n}\n\n@keyframes pulse {\n  0% {\n    box-shadow: 0 0 0 0 rgba(76, 175, 80, 0.6);\n  }\n  70% {\n    box-shadow: 0 0 0 16px rgba(76, 175, 80, 0);\n  }\n  100% {\n    box-shadow: 0 0 0 0 rgba(76, 175, 80, 0);\n  }\n}\n\n.sticky {\n  position: sticky;\n  top: 0;\n  z-index: 1000; /* To make sure it stays above other elements */\n}\n\n.dot {\n  width: 8px;\n  height: 8px;\n  background-color: rgba(24, 116, 210, 0.6);\n  border-radius: 50%;\n  display: inline-block;\n  animation: blink 1.2s infinite ease-in-out;\n}\n.dot:nth-child(2) {\n  animation-delay: 0.2s;\n}\n.dot:nth-child(3) {\n  animation-delay: 0.4s;\n}\n\n@keyframes blink {\n  0%,\n  80%,\n  100% {\n    opacity: 0.3;\n    transform: scale(0.8);\n  }\n  40% {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n/* Enhanced Markdown Styles */\n.markdown-content {\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n  line-height: 1.6;\n  counter-reset: code-block;\n  color: #2c3e50 !important;\n}\n\n.markdown-content pre {\n  background-color: #ffffff;\n  border: 1px solid rgba(24, 116, 210, 0.12);\n  border-radius: 8px;\n  padding: 16px;\n  overflow-x: auto;\n  margin: 16px 0;\n  position: relative;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n}\n\n/* Force dark text for all common markdown elements */\n.markdown-content p,\n.markdown-content li,\n.markdown-content td,\n.markdown-content th,\n.markdown-content blockquote,\n.markdown-content span,\n.markdown-content div {\n  color: #2c3e50 !important;\n}\n\n.markdown-content pre code {\n  background: none;\n  padding: 0;\n  border-radius: 0;\n  font-size: 0.9rem;\n}\n\n.markdown-content table {\n  border-collapse: collapse;\n  width: 100%;\n  margin: 16px 0;\n  font-size: 0.9rem;\n  border: 1px solid rgba(24, 116, 210, 0.12);\n  border-radius: 8px;\n  overflow: hidden;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n}\n\n.markdown-content table th,\n.markdown-content table td {\n  border: 1px solid rgba(24, 116, 210, 0.08);\n  padding: 8px 12px;\n  text-align: left;\n}\n\n.markdown-content table th {\n  background-color: rgba(24, 116, 210, 0.04);\n  font-weight: bold;\n  color: #002855;\n}\n\n.markdown-content table tr:nth-child(even) {\n  background-color: rgba(24, 116, 210, 0.02);\n}\n\n.markdown-content table tr:hover {\n  background-color: rgba(24, 116, 210, 0.04);\n}\n\n.markdown-content blockquote {\n  border-left: 4px solid rgba(24, 116, 210, 1);\n  margin: 16px 0;\n  padding: 12px 16px;\n  background-color: rgba(24, 116, 210, 0.04);\n  border-radius: 0 4px 4px 0;\n  font-style: italic;\n  position: relative;\n  border: 1px solid rgba(24, 116, 210, 0.08);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n}\n\n.markdown-content blockquote p {\n  margin: 0;\n}\n\n.markdown-content ul,\n.markdown-content ol {\n  padding-left: 24px;\n  margin: 16px 0;\n}\n\n.markdown-content li {\n  margin-bottom: 4px;\n  line-height: 1.6;\n}\n\n.markdown-content img {\n  max-width: 100%;\n  height: auto;\n  border-radius: 8px;\n  margin: 16px 0;\n}\n\n.markdown-content a {\n  color: #1976d2;\n  text-decoration: underline;\n}\n\n.markdown-content a:hover {\n  color: #1565c0;\n}\n\n.markdown-content hr {\n  border: 1px solid #e0e0e0;\n  margin: 24px 0;\n}\n\n/* Syntax Highlighter Custom Styles */\n.markdown-content .token.comment,\n.markdown-content .token.prolog,\n.markdown-content .token.doctype,\n.markdown-content .token.cdata {\n  color: #6a737d;\n}\n\n.markdown-content .token.punctuation {\n  color: #586069;\n}\n\n.markdown-content .token.property,\n.markdown-content .token.tag,\n.markdown-content .token.boolean,\n.markdown-content .token.number,\n.markdown-content .token.constant,\n.markdown-content .token.symbol,\n.markdown-content .token.deleted {\n  color: #005cc5;\n}\n\n.markdown-content .token.selector,\n.markdown-content .token.attr-name,\n.markdown-content .token.string,\n.markdown-content .token.char,\n.markdown-content .token.builtin,\n.markdown-content .token.inserted {\n  color: #032f62;\n}\n\n.markdown-content .token.operator,\n.markdown-content .token.entity,\n.markdown-content .token.url,\n.markdown-content .language-css .token.string,\n.markdown-content .style .token.string {\n  color: #d73a49;\n}\n\n.markdown-content .token.atrule,\n.markdown-content .token.attr-value,\n.markdown-content .token.keyword {\n  color: #d73a49;\n}\n\n.markdown-content .token.function,\n.markdown-content .token.class-name {\n  color: #6f42c1;\n}\n\n.markdown-content .token.regex,\n.markdown-content .token.important,\n.markdown-content .token.variable {\n  color: #e36209;\n}\n\n/* Chat Layout Fixes */\n.chat-container {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  overflow: hidden;\n  /* Ensure consistent width for non-fullscreen mode */\n  width: 480px;\n  max-width: 480px;\n  min-width: 480px;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n/* Fullscreen mode overrides */\n.chat-container.fullscreen {\n  width: 100% !important;\n  max-width: 100% !important;\n  min-width: auto !important;\n}\n\n.chat-header {\n  flex-shrink: 0;\n  overflow: hidden;\n}\n\n.chat-body {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n\n.chat-input {\n  flex-shrink: 0;\n  width: 100%;\n  position: relative;\n  z-index: 1;\n}\n\n/* Prevent content overflow during streaming */\n.markdown-content {\n  max-width: 100%;\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n  hyphens: auto;\n}\n\n/* Fade overlay for collapsible code blocks */\n.markdown-content .code-fade-overlay {\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  height: 48px;\n  background: linear-gradient(\n    to bottom,\n    rgba(248, 249, 250, 0),\n    rgba(248, 249, 250, 1)\n  );\n  pointer-events: none;\n}\n\n/* Context marker button subtle style */\n.markdown-content .context-marker-button {\n  box-shadow: 0 2px 4px rgba(24, 116, 210, 0.1);\n  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.markdown-content .context-marker-button:hover {\n  box-shadow: 0 4px 8px rgba(24, 116, 210, 0.2);\n  transform: translateY(-1px);\n}\n\n/* Ensure proper text wrapping in chat messages */\n.chat-message {\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n  max-width: 100%;\n  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n/* Smooth animations for message appearance */\n@keyframes messageSlideIn {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.chat-message {\n  animation: messageSlideIn 0.3s ease-out;\n}\n\n/* Responsive Design */\n@media (max-width: 960px) {\n  .chat-container:not(.fullscreen) {\n    width: 100% !important;\n    max-width: 100% !important;\n    min-width: 100% !important;\n  }\n\n  .markdown-content table {\n    font-size: 0.85rem;\n  }\n\n  .markdown-content table th,\n  .markdown-content table td {\n    padding: 8px 10px;\n  }\n\n  .markdown-content pre {\n    padding: 14px;\n    font-size: 0.85rem;\n  }\n}\n\n@media (max-width: 768px) {\n  .chat-container:not(.fullscreen) {\n    width: 100% !important;\n    max-width: 100% !important;\n    min-width: 100% !important;\n  }\n\n  .markdown-content table {\n    font-size: 0.8rem;\n    display: block;\n    overflow-x: auto;\n    white-space: nowrap;\n  }\n\n  .markdown-content table th,\n  .markdown-content table td {\n    padding: 6px 8px;\n  }\n\n  .markdown-content pre {\n    padding: 12px;\n    font-size: 0.8rem;\n    overflow-x: auto;\n  }\n\n  .markdown-content ul,\n  .markdown-content ol {\n    padding-left: 20px;\n  }\n\n  .markdown-content blockquote {\n    padding: 10px 14px;\n    margin: 12px 0;\n  }\n}\n\n@media (max-width: 600px) {\n  .chat-container:not(.fullscreen) {\n    width: 100% !important;\n    max-width: 100% !important;\n    min-width: 100% !important;\n  }\n\n  .markdown-content {\n    font-size: 0.9rem;\n  }\n\n  .markdown-content table {\n    font-size: 0.75rem;\n  }\n\n  .markdown-content table th,\n  .markdown-content table td {\n    padding: 5px 6px;\n  }\n\n  .markdown-content pre {\n    padding: 10px;\n    font-size: 0.75rem;\n  }\n\n  .markdown-content ul,\n  .markdown-content ol {\n    padding-left: 18px;\n  }\n\n  .markdown-content blockquote {\n    padding: 8px 12px;\n    margin: 10px 0;\n  }\n\n  .markdown-content h1 {\n    font-size: 1.5rem;\n  }\n\n  .markdown-content h2 {\n    font-size: 1.3rem;\n  }\n\n  .markdown-content h3 {\n    font-size: 1.1rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .chat-container:not(.fullscreen) {\n    width: 100% !important;\n    max-width: 100% !important;\n    min-width: 100% !important;\n  }\n\n  .markdown-content {\n    font-size: 0.85rem;\n  }\n\n  .markdown-content table {\n    font-size: 0.7rem;\n  }\n\n  .markdown-content table th,\n  .markdown-content table td {\n    padding: 4px 5px;\n  }\n\n  .markdown-content pre {\n    padding: 8px;\n    font-size: 0.7rem;\n  }\n\n  .markdown-content ul,\n  .markdown-content ol {\n    padding-left: 16px;\n  }\n\n  .markdown-content blockquote {\n    padding: 6px 10px;\n    margin: 8px 0;\n    font-size: 0.85rem;\n  }\n\n  .markdown-content h1 {\n    font-size: 1.3rem;\n  }\n\n  .markdown-content h2 {\n    font-size: 1.15rem;\n  }\n\n  .markdown-content h3 {\n    font-size: 1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
